import axios from "axios"

const postUserLog=async(url,action,code)=>{
        
        await axios.post(url,
            {
            "fkIdStaff": sessionStorage.getItem('idUser'),
            "userAction": action,
            "code": code,
            "iPaddress": '0.0.0.0'
            }, {
                'Content-Type': 'application/json',
                accept: 'application/json',
        }).then((response) => {
            // console.log(response);
        }).catch(error=>{
            console.log(error);
        })
    
   }

   const paymentMethodFormat=(pm)=>{
    if(pm==="AM"){
        return "Dépôt Marchand"
    }
    if(pm==="SM"){
        return "Dépôt Agence"
    }
    if(pm==="DP"){
        return "Dépôt Client"
    }
    if(pm==="OM"){
        return "Orange Money"
    }
    if(pm==="WF"){
        return "Cash"
    }
     if(pm==="MTN"){
        return "MTN"
    }
   else{
        return "NAN"
    }
   }
   const errorMessage=(errorCode)=>{
    if(errorCode===400){
        return 'Une erreur s’est produite';
    } else if(errorCode===460){
        return'La transaction est introuvable';
    }
    else if(errorCode===450){
        return"Pourcentage d'achat non définit !";
    }
    else if(errorCode===440){
        return'Monde de paiement introuvable';
    }
    else if(errorCode===300){
        return 'Destinataire non trouvé';
    }
    else if(errorCode===305){
        return 'La somme n’est pas dans l’intervalle permis';
    }
    else if(errorCode===320){
        return 'Votre compte n’est pas actif';
    }
    else if(errorCode===322){
        return 'Votre compte est bloqué';
    }
    else if(errorCode===330){
        return 'Login ou mot de passe incorrect';
    }
    else if(errorCode===332){
        return 'Phone ou mot de passe incorrect';
    }
    else if(errorCode===350){
        return 'Ce compte existe déjà';
    }
    else if(errorCode===340){
        return 'Le montant sur votre compte est insuffisant';
    }
    else if(errorCode===370){
        return 'Votre n’êtes habilité à effectuer cette opération';
    }
    else if(errorCode===420){
        return 'Utilisateur de l’agence est introuvable';
    }
    else if(errorCode===421){
        return 'Agence de l’utilisateur est introuvable';
    }
    else if(errorCode===423){
        return 'Le Master de l’agence est Introuvable';
    }
    else if(errorCode===505){
        return 'Transaction déjà validée';
    }
    else if(errorCode===506){
        return "Vous ne pouvez pas valider une transaction d'une autre entreprise";
    }
    else if(errorCode===507){
        return "L’agent n’est pas affecté à une entreprise";
    }
    else if(errorCode===600){
        return "Méthode de paiement introuvable";
    }
    else if(errorCode===601){
        return "Master introuvable";
    }
    else if(errorCode===601){
        return "Master introuvable";
    }
    else if(errorCode===602){
        return "frai non configuré";
    }
    else if(errorCode===102){
        return "Frai non trouvé";
    }
    else if(errorCode===103){
        return "Utilisateur introuvable";
    }
   }

   export {
    postUserLog,
    errorMessage,
    paymentMethodFormat
   }
